import { render } from "./promotionActivate.vue?vue&type=template&id=096d557a&scoped=true"
import script from "./promotionActivate.vue?vue&type=script&lang=js"
export * from "./promotionActivate.vue?vue&type=script&lang=js"

import "./promotionActivate.vue?vue&type=style&index=0&id=096d557a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096d557a"]])

export default __exports__